import { apiFactory, headers } from '~/src/dash/api/api-factory';
import { retryFunc } from '~/src/dash/api/console-api';
import { Auth } from '~/src/dash/api/transform-auth';

export const queryDemandSources = apiFactory({
  method: 'POST',
  headers,
  body: {
    core_section: 'settings',
    core_action: 'get_demand_sources_for_dashboard',
  },
  retryCount: 1,
  retryFunc,
  transformQuery: Auth.appendToken,
  transformResponse: (err: any, json: any) => {
    if (err) {
      return new Error((json && json.msg) || 'request failed');
    }
    return json.demandSources;
  },
});
